import axios from 'axios';

const defaultAPIKey = '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';

export const chat = async (message: string): Promise<string | undefined> => {
  const endpoint = 'https://api.openai.com/v1/chat/completions';
  const params = {
    messages: [
      {
        role: 'user',
        content: message,
      },
    ],
    model: 'gpt-4',
    max_tokens: 4000,
    temperature: 0,
  };
  // Define the headers for the request
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${defaultAPIKey}`,
  };

  try {
    const result = await axios.post(endpoint, params, { headers });
    return result.data.choices[0].message.content;
  } catch (e) {
    console.log(e);
    alert('OpenAI API Error');
    return undefined;
  }
};

const getPrompt = (context: string, sentence: string): string => {
  return (
    `In the context of "${context}", given the following sentence:\n\n` +
    `--begining--\n\n ${sentence} \n\n--end--\n\n` +
    'kindly rate, rewrite, and offer feedback about this sentence with adhering to these guidelines: \n' +
    '1. Rate the sentences on a scale of 100 points considering these factors \n' +
    `- Appropriateness of the sentence according to the given context(${context})` +
    '(e.g. In the context of a casual chat inquiry, overly formal sentences are inappropriate): 60% weight \n' +
    '- Consistency in language usage: 20% weight \n' +
    '- Presence of any grammatical errors: 20% weight \n' +
    '2. Rewrite the text in context to achieve a perfect score (100 points) in English, ' +
    'using appropriate line breaks for readability. \n' +
    '3. If the sentence length is too short or long, kindly adjust it accordingly. \n' +
    '4. Begin the rewritten text with "Body:" for easy identification of the revised message. \n' +
    '5. Begin the feedback with "Feedback:" for easy identification of the feedback section. \n' +
    '6. Begin the score text with "Score: ${score}" format for easy identification of the score. \n' +
    '7. Present your response in the following order: score, "Body:", "Feedback:"." \n' +
    '8. Limit your suggestions for improvement to 150 words or less.'
  );
};
export const getFeedBackFromOpenAIWithTurbo = async (
  sentence: string,
  context: string,
  apiKey = defaultAPIKey
): Promise<{
  score: number;
  body: string;
  feedback: string;
}> => {
  const endpoint = 'https://api.openai.com/v1/chat/completions';
  const params = {
    messages: [
      {
        role: 'user',
        content: getPrompt(context, sentence),
      },
    ],
    // model: 'text-davinci-003',
    model: 'gpt-4',
    max_tokens: 3000,
    temperature: 0,
  };
  // Define the headers for the request
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${apiKey}`,
  };

  const BODY_TEXT_TAG = 'Body:';
  const FEEDBACL_TEXT_TAG = 'Feedback:';
  try {
    const result = await axios.post(endpoint, params, { headers });
    const resultText = result.data.choices[0].message.content;

    // scoreの取得
    const scoreRegex = /Score: \d+/;
    const scoreText = resultText.match(scoreRegex)[0];
    const score = scoreText.split('Score: ')[1];

    // OpenAIによってrewriteされた本文の取得
    let body = resultText.split(scoreText)[1];
    body =
      body.indexOf(BODY_TEXT_TAG) > 0 ? body.split(BODY_TEXT_TAG)[1] : body;
    body = body.split(FEEDBACL_TEXT_TAG)[0];

    // Feedbackテキストの取得
    const feedback = resultText.split(FEEDBACL_TEXT_TAG)[1];

    // 先頭の改行を削除
    body = body.replace(/^\n+/g, '');
    return {
      score,
      body,
      feedback,
    };
  } catch (e) {
    console.log(e);
    alert('OpenAI API Error');
    return {
      score: 0,
      body: '',
      feedback: '',
    };
  }
};

export const getFeedBackFromOpenAI = async (
  sentence: string,
  context: string,
  apiKey = defaultAPIKey
): Promise<{
  score: number;
  body: string;
  feedback: string;
}> => {
  const endpoint = 'https://api.openai.com/v1/completions';
  const params = {
    prompt: getPrompt(context, sentence),
    model: 'text-davinci-003',
    max_tokens: 3000,
    temperature: 0,
  };
  // Define the headers for the request
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${apiKey}`,
  };

  const BODY_TEXT_TAG = 'Body:';
  const FEEDBACL_TEXT_TAG = 'Feedback:';
  try {
    const result = await axios.post(endpoint, params, { headers });
    const resultText = result.data.choices[0].text;

    // scoreの取得
    const scoreRegex = /Score: \d+/;
    const scoreText = resultText.match(scoreRegex)[0];
    const score = scoreText.split('Score: ')[1];

    // OpenAIによってrewriteされた本文の取得
    let body = resultText.split(scoreText)[1];
    body =
      body.indexOf(BODY_TEXT_TAG) > 0 ? body.split(BODY_TEXT_TAG)[1] : body;
    body = body.split(FEEDBACL_TEXT_TAG)[0];

    // Feedbackテキストの取得
    const feedback = result.data.choices[0].text.split(FEEDBACL_TEXT_TAG)[1];

    // 先頭の改行を削除
    body = body.replace(/^\n+/g, '');

    return {
      score,
      body,
      feedback,
    };
  } catch (e) {
    console.log(e);
    alert('OpenAI API Error');
    return {
      score: 0,
      body: '',
      feedback: '',
    };
  }
};
